import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';

export const projectLinkDataArraySelector = (projectId: string) =>
  createSelector(
    diagramSnapshotSelector(projectId),
    (diagram) => diagram?.model?.linkDataArray || []
  );

export const prevProjectLinkDataArraySelector = (projectId: string) =>
  createSelector(
    diagramSnapshotSelector(projectId),
    (diagram) => diagram?.model?.modelData.draftData?.prevLinkDataArray || []
  );
